import { render, staticRenderFns } from "./EndorsementsProCpeCecr.vue?vue&type=template&id=eed2508a&scoped=true&"
import script from "./EndorsementsProCpeCecr.vue?vue&type=script&lang=js&"
export * from "./EndorsementsProCpeCecr.vue?vue&type=script&lang=js&"
import style0 from "./EndorsementsProCpeCecr.vue?vue&type=style&index=0&id=eed2508a&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eed2508a",
  null
  
)

export default component.exports